"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrincipalBlock = void 0;
const react_1 = __importStar(require("react"));
const notistack_1 = require("notistack");
const authProvider_1 = require("@/components/authProvider/authProvider");
const principal_1 = require("@dfinity/principal");
const Section_1 = require("@/components/Section");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const Amount_1 = __importStar(require("@/components/layout/Amount"));
const CustomCircleChart_1 = require("@/components/charts/CustomCircleChart");
const format_1 = require("@/utils/format");
const styled_components_1 = __importDefault(require("styled-components"));
const principalToAccountId_1 = require("@/utils/principalToAccountId");
const formatDate_1 = require("@/utils/formatDate");
const react_router_dom_1 = require("react-router-dom");
const Chip_1 = require("@/components/Chip");
const fetchData_1 = require("@/utils/fetchData");
const styledComponents_1 = require("@/components/styledComponents");
const Loading_1 = require("@/components/layout/Loading");
const react_2 = require("@connect2ic/react");
const HelmetTitle_1 = __importDefault(require("@/components/interactions/HelmetTitle"));
function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
const LockPeriods = ['OneYear', 'TwoYear', 'ThreeYear', 'FourYear', 'FiveYear'];
const cells = [
    { id: "id", label: "ID", canSort: true },
    { id: "created", label: "Date Created" },
    { id: "lockUp", label: "End Lock Date" },
    { id: "amount", label: "Amount Staked" },
    { id: "rewards", label: "Rewards Earned" },
    { id: "status", label: "Status" },
    { id: "actions", label: "Actions" },
];
const config = {
    baseRate: 5,
    step: 1,
    min: 1,
    max: 5,
    steps: {
        1: 1,
        2: 1.15,
        3: 1.4,
        4: 1.65,
        5: 2,
    },
};
const cellsVesting = [
    { id: "id", label: "ID", canSort: true },
    { id: "created", label: "Date Created" },
    { id: "lockUp", label: "End Lock Date" },
    { id: "amount", label: "Amount Vested" },
    { id: "status", label: "Status" },
    { id: "actions", label: "Actions" },
];
const FEE = 0.002;
const rewardMulty = {
    "1": "1",
    "2": "1.15",
    "3": "1.4",
    "4": "1.65",
    "5": "2",
};
const progressStepMsg = [
    "",
    "Step 1 of 2: Deposit OGYs",
    "Step 2 of 2: Stake tokens",
];
const rewardColorsStart = {
    "1": "#edda25",
    "2": "#691d4d",
    "3": "#1c95ce",
    "4": "#6aaf31",
    "5": "#6aaf31",
};
const rewardColors = {
    "1": "#ef8d12",
    "2": "#803383",
    "3": "#263d86",
    "4": "#016d30",
    "5": "#016d30",
};
const Stakes = () => {
    const { principal, accountID, loggedIn, isLoading: authLoading, handleLogOut } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const [balance, setBalance] = (0, react_1.useState)(0n);
    const [stakedBalance, setStakedBalance] = (0, react_1.useState)(0n);
    const [isStakeOpened, setIsStakeOpened] = (0, react_1.useState)(false);
    const [isTransferOpened, setIsTransferOpened] = (0, react_1.useState)(false);
    const [stakes, setStakes] = (0, react_1.useState)([]);
    const { enqueueSnackbar } = (0, notistack_1.useSnackbar)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [isLoading, setIsLoading] = (0, react_1.useState)();
    const [isStaking, setIsStaking] = (0, react_1.useState)(false);
    const [validActors, setValidActors] = (0, react_1.useState)(false);
    const [exchangeRate, setExchangeRate] = (0, react_1.useState)(0);
    const [rewardSum, setRewardSum] = (0, react_1.useState)(0n);
    const [amountError, setAmountError] = (0, react_1.useState)("");
    const [accountIdError, setAccountIdError] = (0, react_1.useState)("");
    const [progressStep, setProgressStep] = (0, react_1.useState)(0);
    const [stakeAmount, setStakeAmount] = (0, react_1.useState)("0");
    const [stakeStep, setStakeStep] = (0, react_1.useState)(0);
    const [stakePeriod, setStakePeriod] = (0, react_1.useState)("1");
    const [transferAmount, setTransferAmount] = (0, react_1.useState)("0");
    const [recipientAddress, setRecipientAddress] = (0, react_1.useState)("");
    const [isTransfer, setIsTransfer] = (0, react_1.useState)(false);
    const [totalVestings, setTotalVestings] = (0, react_1.useState)(0n);
    const [unclaimedVestings, setUnclaimedVestings] = (0, react_1.useState)(0n);
    const [vestingRewards, setVestingRewards] = (0, react_1.useState)(0n);
    const [vestableVestings, setVestableVestings] = (0, react_1.useState)(0n);
    const [unstaked, setUnstaked] = (0, react_1.useState)(0n);
    const [vestings, setVestings] = (0, react_1.useState)();
    const [metrics, setMetrics] = (0, react_1.useState)();
    const [allVestings, setAllVestings] = (0, react_1.useState)([]);
    const [isClaiming, setIsclaiming] = (0, react_1.useState)(false);
    const [isVesting, setIsVesting] = (0, react_1.useState)(false);
    const [currentRewardRate, setCurrentRewardRate] = (0, react_1.useState)(0);
    const [governanceActor] = (0, react_2.useCanister)('governance', { mode: 'connected' });
    const [vestingActor] = (0, react_2.useCanister)('vesting', { mode: 'connected' });
    const [ledgerActor] = (0, react_2.useCanister)('ledger', { mode: 'connected' });
    const vestVesting = async (vestingId) => {
        setIsVesting(true);
        try {
            enqueueSnackbar("Vesting Stake", {
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            await vestingActor.vest_tokens(vestingId);
            await getBalances();
            enqueueSnackbar("Vested Successfully", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        catch (e) {
            console.log(e);
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        setIsVesting(false);
    };
    const vestAllVesting = async () => {
        setIsVesting(true);
        try {
            enqueueSnackbar("Vesting all Stakes", {
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            const result = await Promise.all(vestings.vestable.map((v) => vestingActor.vest_tokens(v[0])));
            await getBalances();
            enqueueSnackbar("Vested Successfully", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        catch (e) {
            console.log(e);
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        setIsVesting(false);
    };
    const claimVesting = async (vestingId) => {
        setIsclaiming(true);
        try {
            enqueueSnackbar("Claiming Vestings", {
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            await vestingActor.stake_claimable_tokens(vestingId, []);
            await getBalances();
            enqueueSnackbar("Claimed Successfully", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        catch (e) {
            console.log(e);
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        setIsclaiming(false);
    };
    const claimVestings = async () => {
        setIsclaiming(true);
        try {
            enqueueSnackbar("Claiming Vesting", {
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            const result = await Promise.all(vestings.unclaimed.map((v) => vestingActor.stake_claimable_tokens(v[0], [])));
            await getBalances();
            enqueueSnackbar("Claimed Successfully", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        catch (e) {
            console.log(e);
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        setIsclaiming(false);
    };
    const validateActors = async () => {
        const govSym = Object.getOwnPropertySymbols(governanceActor).find((s) => s.description === "ic-agent-metadata");
        const vestSym = Object.getOwnPropertySymbols(vestingActor).find((s) => s.description === "ic-agent-metadata");
        //TODO: look into why vesting actor makes initial call with anon identity...
        await timeout(2000);
        //@ts-ignore
        const governanceAgent = await governanceActor[govSym].config.agent._identity;
        //@ts-ignore
        const vestingAgent = await governanceActor[vestSym].config.agent._identity;
        if (principal.toString() === "2vxsx-fae")
            handleLogOut();
        setValidActors(governanceAgent?.constructor?.name !== "AnonymousIdentity" && vestingAgent?.constructor?.name !== "AnonymousIdentity");
    };
    const getBalances = async () => {
        try {
            if (isLoading === true)
                return;
            setIsLoading(true);
            // const metricsNew = await governanceActor.get_liquidity();
            // console.log("metricsNew", metricsNew);
            const balanceOGY = (await ledgerActor.account_balance_dfx({
                account: accountID,
            }));
            const vesting = await vestingActor.get_balances();
            let total = 0n;
            const unclaimed = vesting.unclaimed.reduce((sum, v) => sum + v[1].quantity, 0n);
            const unvested = vesting.unvested.reduce((sum, v) => sum + v[1].quantity, 0n);
            const vestable = vesting.vestable.reduce((sum, v) => sum + v[1].quantity, 0n);
            setUnclaimedVestings(unclaimed);
            setVestings(vesting);
            setTotalVestings(unclaimed + unvested + vestable);
            setVestableVestings(vestable);
            console.log(principal.toString(), vesting);
            const vestingsFullList = [
                ...vesting.unclaimed.map((v) => ({ ...v[1], status: 'Unclaimed', id: v[0] })),
                ...vesting.unvested.map((v) => ({ ...v[1], status: 'Unvested', id: v[0] })),
                ...vesting.vestable.map((v) => ({ ...v[1], status: 'Vestable', id: v[0] })),
                ...vesting.vested.map((v) => ({ ...v[1], status: 'Vested', id: v[0] })),
            ];
            const mappedVestings = vestingsFullList.reduce((arr, item) => {
                const formatedItem = {
                    id: item?.id?.toString(),
                    created: (0, formatDate_1.formatTime)(item?.startDate),
                    lockUp: (0, formatDate_1.formatTime)(item?.endDate),
                    amount: `${(0, format_1.formatNatAmount)(item?.quantity)} OGY`,
                    status: react_1.default.createElement(Chip_1.Chip, { bgColor: "#D9F3C7", color: "#01630A" },
                        react_1.default.createElement("b", null, item.status)),
                    actions: react_1.default.createElement(react_1.default.Fragment, null,
                        item.status === "Unclaimed" && react_1.default.createElement(origyn_art_ui_1.Button, { disabled: isClaiming, btnType: "outlined", onClick: () => claimVesting(item?.id) }, "Start Vesting"),
                        item.status === "Vestable" && react_1.default.createElement(origyn_art_ui_1.Button, { disabled: isVesting, btnType: "outlined", onClick: () => vestVesting(item?.id) }, "Vest & Stake"))
                };
                return [...arr, formatedItem];
            }, []);
            setAllVestings(mappedVestings);
            const balanceGovernance = await governanceActor.get_balances();
            setUnstaked(balanceGovernance.unstaked);
            let rewardsSum = 0n;
            const mappedStakes = balanceGovernance.staked.reduce((arr, item) => {
                const currentItem = item[1];
                const rewards = currentItem.rewards.reduce((sum, reward) => sum + reward.amount, 0n);
                rewardsSum += rewards;
                const formatedItem = {
                    id: item[0].toString(),
                    idNat: item[0],
                    created: (0, formatDate_1.formatTime)(currentItem.createdDate),
                    lockUp: (0, formatDate_1.formatTime)(currentItem.endLockTime),
                    amount: (0, format_1.formatNatAmount)(currentItem.quantity),
                    quantity: currentItem.quantity,
                    rewards: (0, format_1.formatNatAmount)(rewards),
                    rewardsNat: rewards,
                    status: react_1.default.createElement(Chip_1.Chip, { bgColor: "#D9F3C7", color: "#01630A" },
                        react_1.default.createElement("b", null, "Active")),
                    actions: react_1.default.createElement(origyn_art_ui_1.Button, { btnType: "outlined", as: react_router_dom_1.Link, to: `/stakes/${item[0].toString()}` }, "Manage Stake")
                };
                return [...arr, formatedItem];
            }, []);
            setRewardSum(rewardsSum);
            const exchangeRates = await (0, fetchData_1.getExchangeRateOGY)();
            setExchangeRate(exchangeRates.ogyPrice);
            setStakes(mappedStakes);
            const stakedTokensSum = balanceGovernance.staked.reduce((acc, token) => {
                return acc + token[1].quantity;
            }, 0n);
            setBalance(balanceOGY.e8s);
            setStakedBalance(stakedTokensSum);
            setIsLoading(false);
        }
        catch (e) {
            console.log(e);
            handleLogOut();
        }
    };
    const handleDepositOGY = async () => {
        setProgressStep(1);
        if (parseFloat(stakeAmount) < 0) {
            return;
        }
        let memo_bigint = 0n;
        const e8s = 10 ** 8;
        const amount_e8s = BigInt(Math.round(Number(stakeAmount) * e8s));
        const fee_e8s = BigInt(Math.round(FEE * e8s));
        const totalMinus = amount_e8s + fee_e8s;
        // check recipient validity
        // check BigInt(amount+fee) > walletBalance
        if ((balance || 0n) < totalMinus) {
            alert("Please comfirm your wallet balance. You can't deposit if your balance is under 1000.002 OGY");
            return;
        }
        try {
            const blockHeight = await ledgerActor.send_dfx({
                to: (0, principalToAccountId_1.getAccountId)(principal_1.Principal.fromText(process.env.GOVERNANCE_CANISTER_ID)),
                fee: {
                    e8s: fee_e8s,
                },
                memo: 0,
                from_subaccount: [],
                created_at_time: [],
                amount: { e8s: amount_e8s },
            });
            const result = await governanceActor.redeem_deposit(principal, [], blockHeight);
        }
        catch (e) {
            console.log(e);
        }
    };
    const handleSendOGY = async () => {
        setIsTransfer(true);
        try {
            if (parseFloat(transferAmount) <= 0) {
                setIsTransfer(false);
                return setAmountError("Invalid amount");
            }
            let accountId = recipientAddress;
            try {
                principal_1.Principal.fromText(recipientAddress);
                accountId = (0, principalToAccountId_1.getAccountId)(principal_1.Principal.fromText(recipientAddress));
            }
            catch (error) {
                accountId = recipientAddress;
            }
            let memo_bigint = 0n;
            const e8s = 10 ** 8;
            const amount_e8s = BigInt(Math.round(parseFloat(transferAmount) * e8s));
            const fee_e8s = BigInt(Math.round(FEE * e8s));
            const totalMinus = amount_e8s + fee_e8s;
            const blockHeight = await ledgerActor.send_dfx({
                to: accountId,
                fee: {
                    e8s: fee_e8s,
                },
                memo: memo_bigint,
                from_subaccount: [],
                created_at_time: [],
                amount: { e8s: amount_e8s },
            });
            console.log(blockHeight);
            setIsTransferOpened(false);
            enqueueSnackbar("Transfer was successfull", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            getBalances();
        }
        catch (e) {
            console.error({ e });
            setIsTransfer(false);
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        setIsTransfer(false);
    };
    const handleCreateStakeSave = async (nbYear, amount) => {
        setProgressStep(2);
        const nowNanos = BigInt(Date.now()) * 10n ** 6n;
        const oneDayNanos = 3600n * 24n * 10n ** 9n; // a day devided by 10 (to be able to add half a year)
        const oneYearNanos = BigInt(nbYear) * oneDayNanos * 365n;
        const endLock = nowNanos + // to nanos
            oneYearNanos +
            oneDayNanos; // offset;
        try {
            const amount_e8s = (0, format_1.moveDecimal)(amount);
            const index = await governanceActor.stake_tokens_v1_5(amount_e8s, { [LockPeriods[nbYear - 1]]: null });
            setProgressStep(3);
            getBalances();
            enqueueSnackbar("Stake was created", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
        catch (e) {
            enqueueSnackbar("Something went wrong, contact support for more details", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            console.error({ e });
            throw e;
        }
    };
    const handleStake = async () => {
        setIsStaking(true);
        await handleDepositOGY();
        await handleCreateStakeSave(parseInt(stakePeriod), stakeAmount);
        setIsStaking(false);
    };
    const handleCloseStake = () => {
        setIsStakeOpened(false);
        setIsStaking(false);
        setProgressStep(0);
        setStakeAmount("0");
        setStakeStep(0);
        setStakePeriod("1");
        setAmountError("");
    };
    const handleCloseTransfer = () => {
        setIsTransferOpened(false);
        setIsStaking(false);
        setRecipientAddress('');
        setTransferAmount("0");
    };
    const handleWithdrawUnlocked = async () => {
        try {
            if (!governanceActor)
                throw new Error("governance actor error");
            enqueueSnackbar("Withdraw started", {
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            if (principal.length < 50)
                throw new Error();
            const resp = await governanceActor.withdraw_unlocked_tokens(accountID, unstaked - 200000n);
            enqueueSnackbar("Withdrawn successfully", {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            getBalances();
        }
        catch (e) {
            console.error({ e });
            enqueueSnackbar(e.message || "Something went wrong", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
        }
    };
    const getData = async () => {
        const metrics = await governanceActor.get_metrics();
        const totalLocked = Number(metrics.locked_tier_1) * config.steps[1]
            + Number(metrics.locked_tier_2) * config.steps[2]
            + Number(metrics.locked_tier_3) * config.steps[3]
            + Number(metrics.locked_tier_4) * config.steps[4]
            + Number(metrics.locked_tier_5) * config.steps[5];
        setCurrentRewardRate((Number(metrics.current_epic_rewards)) / (Number(totalLocked)));
        //setCurrentRewardRate(0.05);
        setMetrics(metrics);
    };
    const handleUnstake = async () => {
        try {
            const p = principal_1.Principal.fromText(principal.toString());
            if (principal.toString() === "2vxsx-fae")
                return handleLogOut();
        }
        catch {
            handleLogOut();
        }
        stakes.map(async (stake) => {
            enqueueSnackbar(`Unstaking Stake ${stake.id}`, {
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            try {
                if (!governanceActor)
                    throw new Error("governance actor error");
                try {
                    await governanceActor.redeem_rewards_v1_5(BigInt(stake.idNat), false, []);
                }
                catch (e) {
                    console.log(e);
                }
                const index = await governanceActor.unstake_tokens(BigInt(stake.idNat));
                const resp = await governanceActor.withdraw_unlocked_tokens(accountID, stake.quantity - 200000n);
                enqueueSnackbar("Unstaked successfully", {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                });
                getData();
            }
            catch (e) {
                console.error({ e });
                enqueueSnackbar(e.message || "Something went wrong", {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                });
            }
        });
    };
    (0, react_1.useEffect)(() => {
        validateActors();
    }, [governanceActor, vestingActor]);
    (0, react_1.useEffect)(() => {
        if (validActors) {
            getBalances();
        }
    }, [validActors]);
    (0, react_1.useEffect)(() => {
        getData();
        if (!loggedIn) {
            navigate('/');
        }
    }, []);
    const totalSum = balance + stakedBalance + totalVestings + unstaked + vestingRewards;
    return (react_1.default.createElement(Section_1.Section, null,
        react_1.default.createElement(HelmetTitle_1.default, { title: 'My Account', description: 'Your governance account' }),
        isLoading || isLoading === undefined ?
            react_1.default.createElement(Loading_1.Loading, { style: {
                    height: '400px',
                    gridColumn: 'span 12',
                } }) : react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(origyn_art_ui_1.Card, { style: { position: 'relative' }, align: "center", justify: 'center' },
                react_1.default.createElement("svg", { style: { position: 'absolute', right: 0, bottom: 0 }, xmlns: "http://www.w3.org/2000/svg", width: "1318", height: "594", viewBox: "0 0 1318 594", fill: "none" },
                    react_1.default.createElement("rect", { width: "1318", height: "594", rx: "23", fill: "url(#paint0_linear_354_734)" }),
                    react_1.default.createElement("defs", null,
                        react_1.default.createElement("linearGradient", { id: "paint0_linear_354_734", x1: "1148.5", y1: "-5.26555e-05", x2: "1297.09", y2: "289.397", gradientUnits: "userSpaceOnUse" },
                            react_1.default.createElement("stop", { "stop-color": "#FCFDFF", "stop-opacity": "0.85" }),
                            react_1.default.createElement("stop", { offset: "1", "stop-color": "#CFD2E0" })))),
                react_1.default.createElement(origyn_art_ui_1.Flex, { style: { position: 'relative', padding: 40, maxWidth: 640, textAlign: 'center' }, align: "center", justify: 'center', flexFlow: 'column', gap: 16 },
                    react_1.default.createElement(origyn_art_ui_1.Flex, null,
                        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "24", viewBox: "0 0 25 24", fill: "none" },
                            react_1.default.createElement("rect", { x: "0.5", width: "24", height: "24", rx: "12", fill: "#FB7474" }),
                            react_1.default.createElement("path", { d: "M9.14575 7.81436C10.2614 5.88205 10.8192 4.9159 11.5554 4.60644C12.1435 4.35922 12.8064 4.35922 13.3945 4.60644C14.1307 4.9159 14.6885 5.88205 15.8041 7.81436L18.5076 12.497C19.6232 14.4293 20.1811 15.3955 20.081 16.1878C20.001 16.8207 19.6696 17.3948 19.1614 17.7805C18.5253 18.2633 17.4097 18.2633 15.1785 18.2633H9.7714C7.54016 18.2633 6.42455 18.2633 5.78845 17.7805C5.28029 17.3948 4.94884 16.8207 4.86889 16.1878C4.7688 15.3955 5.3266 14.4293 6.44222 12.497L9.14575 7.81436Z", fill: "white" }),
                            react_1.default.createElement("rect", { x: "11.7134", y: "8.13806", width: "1.52288", height: "5.61292", rx: "0.761442", fill: "#FB7474" }),
                            react_1.default.createElement("rect", { x: "11.7134", y: "14.8389", width: "1.52288", height: "1.52288", rx: "0.761442", fill: "#FB7474" }))),
                    react_1.default.createElement("p", { style: { fontSize: 18 } },
                        "All your tokens staked in the legacy ORIGYN governance have been unlocked and ",
                        react_1.default.createElement("b", null, "you are no longer receiving any rewards"),
                        "."),
                    react_1.default.createElement("p", { style: { fontSize: 14, color: '#69737C' } },
                        react_1.default.createElement("b", null, "Withdraw"),
                        " them from the legacy ORIGYN governance and ",
                        react_1.default.createElement("b", null, "swap"),
                        " them to the new OGY token on the new dashboard    . You can then stake them again in the SNS ORIGYN governance to participate in the network and receive staking rewards."),
                    react_1.default.createElement(origyn_art_ui_1.Button, { to: "https://dashboard.origyn.com/", as: react_router_dom_1.Link, btnType: 'filled' },
                        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "9", height: "9", viewBox: "0 0 9 9" },
                            react_1.default.createElement("path", { d: "M1.73077 2.12569H1.23077V2.62569V7.54877V8.04877H1.73077H6.65385H7.15385V7.54877V6.93339C7.15385 6.86965 7.2055 6.818 7.26923 6.818C7.33297 6.818 7.38462 6.86965 7.38462 6.93339V7.54877C7.38462 7.95238 7.05746 8.27954 6.65385 8.27954H1.73077C1.32717 8.27954 1 7.95238 1 7.54877V2.62569C1 2.2221 1.32718 1.89493 1.73077 1.89493H2.34615C2.40988 1.89493 2.46154 1.94659 2.46154 2.01031C2.46154 2.07403 2.40988 2.12569 2.34615 2.12569H1.73077ZM5.42073 1.27954H8V3.85532C8 3.91905 7.94835 3.97071 7.88462 3.97071C7.82088 3.97071 7.76923 3.91905 7.76923 3.85532V2.88058V1.67348L6.91568 2.52703L4.27919 5.1635L4.27919 5.16351C4.23413 5.20856 4.16108 5.20856 4.11602 5.16351L4.11601 5.1635C4.07095 5.11844 4.07095 5.04539 4.11601 5.00033L3.77068 4.65499L4.11601 5.00033L6.75251 2.36387L7.60607 1.51031H6.39895H5.42073C5.35701 1.51031 5.30535 1.45865 5.30535 1.39493C5.30535 1.3312 5.35701 1.27954 5.42073 1.27954Z", stroke: "white" })),
                        "Go to new dashboard"))),
            react_1.default.createElement(origyn_art_ui_1.Card, { bgColor: "NAVIGATION_BACKGROUND", padding: "24px 26px" },
                react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: "column", gap: 24 },
                    react_1.default.createElement("h4", null, "Total Balance"),
                    react_1.default.createElement(origyn_art_ui_1.Grid, { columns: 2, gap: 24 },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column" },
                            react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Big, amount: (0, format_1.formatNatAmount)(totalSum) }),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 12 },
                                react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                    react_1.default.createElement("b", null,
                                        "Value: $",
                                        (Number(totalSum) / 10e7 * exchangeRate).toLocaleString()),
                                    " ",
                                    react_1.default.createElement("span", null,
                                        "(1 OGY = $",
                                        exchangeRate.toString(),
                                        " USD)")),
                                react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                    "Last Updated: ",
                                    new Date().toLocaleDateString()))),
                        react_1.default.createElement(origyn_art_ui_1.Card, { bgColor: "BACKGROUND", padding: "24px" },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, gap: 12, flexFlow: "column" },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { align: "center", fullWidth: true, gap: 12 },
                                    react_1.default.createElement("b", { style: { whiteSpace: 'nowrap' } }, "Principal:"),
                                    " ",
                                    react_1.default.createElement(exports.PrincipalBlock, { text: principal.toString() })),
                                react_1.default.createElement(origyn_art_ui_1.Flex, { align: "center", gap: 12 },
                                    react_1.default.createElement("b", { style: { whiteSpace: 'nowrap' } }, "Account ID:"),
                                    " ",
                                    react_1.default.createElement(exports.PrincipalBlock, { text: accountID }))))),
                    react_1.default.createElement(origyn_art_ui_1.Grid, { columns: totalVestings ? 3 : 2, lgColumns: 1, gap: 24 },
                        react_1.default.createElement(origyn_art_ui_1.Card, { bgColor: "BACKGROUND", padding: "24px" },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 12, flexFlow: "column" },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 16 },
                                    react_1.default.createElement(CustomCircleChart_1.CircleChart, { percentage: balance ? Math.floor(Number(Number(balance) / Number(totalSum)) * 100).toString() : "0", width: "90", color: "#AA36BF" }),
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", gap: 4 },
                                        react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                            react_1.default.createElement("b", null, "Available OGY")),
                                        react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Medium, amount: (0, format_1.formatNatAmount)(balance) }),
                                        react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                            "Value: ",
                                            `$ ${(Number(balance) / 10e7 * exchangeRate).toLocaleString()} USD`))),
                                react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 24, flexWrap: 'wrap' },
                                    react_1.default.createElement(origyn_art_ui_1.Button, { btnType: "filled", onClick: () => setIsTransferOpened(true) }, "Transfer"),
                                    react_1.default.createElement(origyn_art_ui_1.Button, { disabled: true, btnType: "filled", onClick: () => setIsStakeOpened(true) }, "Stake"),
                                    react_1.default.createElement(origyn_art_ui_1.Button, { as: react_router_dom_1.Link, to: `/transactions`, btnType: "filled" }, "Transactions")))),
                        react_1.default.createElement(origyn_art_ui_1.Card, { bgColor: "BACKGROUND", padding: "24px" },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 12, flexFlow: "column", fullWidth: true },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 16 },
                                    react_1.default.createElement(CustomCircleChart_1.CircleChart, { percentage: stakedBalance ? Math.ceil(Number(Number(stakedBalance) / Number(totalSum)) * 100).toString() : "0", width: "90", color: "#70CDDA" }),
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", gap: 4 },
                                        react_1.default.createElement("p", null, "Staked OGY"),
                                        react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Medium, amount: (0, format_1.formatNatAmount)(stakedBalance) }),
                                        react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                            "Value: ",
                                            `$ ${(Number(stakedBalance) / 10e7 * exchangeRate).toLocaleString()} USD`))),
                                react_1.default.createElement(origyn_art_ui_1.Button, { btnType: 'filled', onClick: handleUnstake }, "Unstake ALL"),
                                unstaked > 10000000n && (react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true, bgColor: "NAVIGATION_BACKGROUND", padding: "24px 16px" },
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, align: "center", justify: "space-between" },
                                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 4 },
                                            react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                react_1.default.createElement("b", null, "Unstaked Tokens")),
                                            react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: (0, format_1.formatNatAmount)(unstaked) }),
                                            react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                "Value: $",
                                                (Number(unstaked) / 10e7 * exchangeRate).toLocaleString(),
                                                " USD")),
                                        react_1.default.createElement(origyn_art_ui_1.Button, { disabled: isClaiming, onClick: handleWithdrawUnlocked }, "Withdraw")))),
                                react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true, bgColor: "NAVIGATION_BACKGROUND", padding: "24px 16px" },
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 4 },
                                        react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                            react_1.default.createElement("b", null, "Staking Rewards")),
                                        react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: (0, format_1.formatNatAmount)(rewardSum) }),
                                        react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                            "Value: $",
                                            (Number(rewardSum) / 10e7 * exchangeRate).toLocaleString(),
                                            " USD"))))),
                        totalVestings ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(origyn_art_ui_1.Card, { bgColor: "BACKGROUND", padding: "24px" },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 12, flexFlow: "column", fullWidth: true },
                                    react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 16 },
                                        react_1.default.createElement(CustomCircleChart_1.CircleChart, { percentage: totalVestings ? Math.ceil(Number(Number(totalVestings) / Number(totalSum)) * 100).toString() : "0", width: "90", color: "#83C657" }),
                                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", gap: 4 },
                                            react_1.default.createElement("p", null, "Vesting OGY (Locked)"),
                                            react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Medium, amount: (0, format_1.formatNatAmount)(totalVestings) }),
                                            react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                "Value: ",
                                                `$ ${(Number(totalVestings) / 10e7 * exchangeRate).toLocaleString()} USD`))),
                                    unclaimedVestings && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true, bgColor: "NAVIGATION_BACKGROUND", padding: "24px 16px" },
                                            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, align: "center", justify: "space-between" },
                                                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 4 },
                                                    react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                        react_1.default.createElement("b", null, "Unclaimed vestings")),
                                                    react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: (0, format_1.formatNatAmount)(unclaimedVestings) }),
                                                    react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                        "Value: $",
                                                        (Number(unclaimedVestings) / 10e7 * exchangeRate).toLocaleString(),
                                                        " USD")),
                                                react_1.default.createElement(origyn_art_ui_1.Button, { disabled: isClaiming, onClick: claimVestings }, "Start Vesting"))))),
                                    vestableVestings && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true, bgColor: "NAVIGATION_BACKGROUND", padding: "24px 16px" },
                                            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, align: "center", justify: "space-between" },
                                                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 4 },
                                                    react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                        react_1.default.createElement("b", null, "Vestable vestings")),
                                                    react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: (0, format_1.formatNatAmount)(vestableVestings) }),
                                                    react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                        "Value: $",
                                                        (Number(vestableVestings) / 10e7 * exchangeRate).toLocaleString(),
                                                        " USD")),
                                                react_1.default.createElement(origyn_art_ui_1.Button, { disabled: isVesting, onClick: vestAllVesting }, "Vest & Stake"))))),
                                    vestingRewards > 0 && (react_1.default.createElement(origyn_art_ui_1.Card, { fullWidth: true, bgColor: "NAVIGATION_BACKGROUND", padding: "24px 16px" },
                                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 4 },
                                            react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                react_1.default.createElement("b", null, "Vesting Rewards")),
                                            react_1.default.createElement(Amount_1.default, { size: Amount_1.AmountSize.Small, amount: (0, format_1.formatNatAmount)(vestingRewards) }),
                                            react_1.default.createElement("p", { style: { opacity: 0.5 } },
                                                "Value: $",
                                                (Number(vestingRewards) / 10e7 * exchangeRate).toLocaleString(),
                                                " USD")))))))) : (react_1.default.createElement(react_1.default.Fragment, null))))),
            allVestings.length > 0 ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(origyn_art_ui_1.TabContent, { tabs: [
                        { id: '', title: `Stakes (${stakes.length.toString()})` },
                        { id: '', title: `Vestings (${allVestings.length.toString()})` },
                    ], content: [
                        react_1.default.createElement(react_1.default.Fragment, null, stakes.length ? react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(styledComponents_1.TableWrap, null,
                                react_1.default.createElement(origyn_art_ui_1.CustomTable, { cells: cells, rows: stakes }))) : react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("h4", null, "You have no stakes at the moment"),
                            react_1.default.createElement("br", null))),
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(styledComponents_1.TableWrap, null,
                                react_1.default.createElement(origyn_art_ui_1.CustomTable, { cells: cellsVesting, rows: allVestings })))
                    ] })) : react_1.default.createElement(react_1.default.Fragment, null, stakes.length ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styledComponents_1.TableWrap, null,
                    react_1.default.createElement(origyn_art_ui_1.CustomTable, { cells: cells, rows: stakes }))) : react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h4", null, "You have no stakes at the moment"))),
            react_1.default.createElement(origyn_art_ui_1.Modal, { size: "md", isOpened: isTransferOpened, closeModal: handleCloseTransfer }, isTransfer ? (react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" },
                react_1.default.createElement("h2", null, "Transfer in progress"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 32 },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                            react_1.default.createElement("h2", null, "Transfer OGY"),
                            react_1.default.createElement("p", null, "You can only send OGY from your available balance.")),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 8 },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'space-between' },
                                react_1.default.createElement("b", null, "Amount"),
                                react_1.default.createElement("p", null,
                                    "Balance: ",
                                    (0, format_1.formatNatAmount)(balance),
                                    " OGY")),
                            react_1.default.createElement(origyn_art_ui_1.TextInput, { value: transferAmount, type: "number", onChange: (e) => { setTransferAmount(e.target.value); }, error: amountError, placeholder: 'Enter amount to send OGY' }),
                            react_1.default.createElement(origyn_art_ui_1.TextInput, { label: "Recipient Address", value: recipientAddress, onChange: (e) => { setRecipientAddress(e.target.value); }, error: accountIdError, placeholder: 'Enter recipient address' })),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
                            react_1.default.createElement("b", null, "Transaction Fee"),
                            react_1.default.createElement("p", null, "0.002 OGY")))),
                react_1.default.createElement(origyn_art_ui_1.HR, null),
                react_1.default.createElement(origyn_art_ui_1.Container, { padding: "32px 48px" },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'space-between' },
                        react_1.default.createElement("b", null, "Amount"),
                        react_1.default.createElement("p", null,
                            parseFloat(transferAmount) + 0.002,
                            " OGY"))),
                react_1.default.createElement(origyn_art_ui_1.HR, null),
                react_1.default.createElement(origyn_art_ui_1.Container, { padding: "32px 48px" },
                    react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'flex-end' },
                        react_1.default.createElement(origyn_art_ui_1.Button, { onClick: handleCloseStake }, "Cancel"),
                        react_1.default.createElement(origyn_art_ui_1.Button, { onClick: () => {
                                if (balance < BigInt(parseInt(transferAmount) * 10e7)) {
                                    setAmountError("Your balance is insuficient!");
                                }
                                else {
                                    handleSendOGY();
                                }
                            } }, "Transfer OGY")))))),
            react_1.default.createElement(origyn_art_ui_1.Modal, { size: "md", isOpened: isStakeOpened, closeModal: handleCloseStake }, progressStep > 0 ? (react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" }, progressStep === 3 ? (react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                react_1.default.createElement("h2", null, "Success!"),
                react_1.default.createElement("p", null,
                    "Your ",
                    stakeAmount,
                    " OGY have been staked sucessfully."),
                react_1.default.createElement(origyn_art_ui_1.Flex, { justify: "flex-end" },
                    react_1.default.createElement(origyn_art_ui_1.Button, { onClick: handleCloseStake }, "Done")))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h2", null, "Stake in Progress"),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement(origyn_art_ui_1.Flex, { align: "center", justify: 'center' }, progressStepMsg[progressStep]),
                react_1.default.createElement(StyledProgress, { progress: (progressStep / 2 * 100).toString() }))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                stakeStep === 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 32 },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                                react_1.default.createElement("h2", null, "Set Stake Amount"),
                                react_1.default.createElement("p", null, "Specify the quantity you want to stake. The staking minimum is 1,000 OGY.")),
                            react_1.default.createElement("h6", null, "Set Amount of OGY to Stake"),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 8 },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'space-between' },
                                    react_1.default.createElement("b", null, "Amount"),
                                    react_1.default.createElement("p", null,
                                        "Balance: ",
                                        (0, format_1.formatNatAmount)(balance),
                                        " OGY")),
                                react_1.default.createElement(AmountInputWrap, null,
                                    react_1.default.createElement(origyn_art_ui_1.TextInput, { value: stakeAmount, type: "number", onChange: (e) => { setAmountError(""); setStakeAmount(e.target.value); }, error: amountError, placeholder: 'Enter amount to send OGY' }),
                                    react_1.default.createElement(origyn_art_ui_1.Button, { onClick: () => setStakeAmount(((Number(balance) / 10e7) - 0.002).toString()), size: 'small', btnType: 'filled', style: { position: 'absolute', right: 20, top: 12 } }, "Max"))),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column' },
                                react_1.default.createElement("b", null, "Transaction Fee"),
                                react_1.default.createElement("p", null, "0.002 OGY")))),
                    react_1.default.createElement(origyn_art_ui_1.HR, null),
                    react_1.default.createElement(origyn_art_ui_1.Container, { padding: "32px 48px" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'space-between' },
                            react_1.default.createElement("b", null, "Amount"),
                            react_1.default.createElement("p", null,
                                parseFloat(stakeAmount) + 0.002,
                                " OGY"))),
                    react_1.default.createElement(origyn_art_ui_1.HR, null),
                    react_1.default.createElement(origyn_art_ui_1.Container, { padding: "32px 48px" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'flex-end' },
                            react_1.default.createElement(origyn_art_ui_1.Button, { onClick: handleCloseStake }, "Cancel"),
                            react_1.default.createElement(origyn_art_ui_1.Button, { onClick: () => {
                                    if (balance < BigInt(Math.floor((parseFloat(stakeAmount) + 0.002) * 10e7))) {
                                        setAmountError("Your balance is insuficient!");
                                    }
                                    else if (parseFloat(stakeAmount) < 1000) {
                                        setAmountError("Minimal amount for stake is 1000 OGY!");
                                    }
                                    else {
                                        setStakeStep(1);
                                    }
                                } }, "Next"))))),
                stakeStep === 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(origyn_art_ui_1.Container, { padding: "48px" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 32 },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 16 },
                                react_1.default.createElement("h2", null, "Specify Lock Period"),
                                react_1.default.createElement("p", { style: { opacity: '0.5' } }, "Choose how long you\u2019d like to lock up your stake. Locking your stake for longer durations allows you to earn rewards faster.")),
                            react_1.default.createElement(CustomSliderSelect, { value: stakePeriod, onChange: setStakePeriod })),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 4 },
                            react_1.default.createElement("b", null,
                                "Reward Multiplier: ",
                                react_1.default.createElement("span", { style: { color: rewardColors[stakePeriod] } },
                                    rewardMulty[stakePeriod],
                                    "X Reward"))),
                        react_1.default.createElement("p", { style: { opacity: '0.5' } },
                            "Estimated effective reward rate (based on current base rate): ",
                            (Math.round(((parseFloat(rewardMulty[stakePeriod]) * (currentRewardRate * 100)) + Number.EPSILON) * 100) / 100).toLocaleString(),
                            "%"),
                        react_1.default.createElement("p", { style: { opacity: '0.5' } },
                            "Estimated annual reward rate (based on above rate): ",
                            (Number(stakeAmount) / 100 * (Math.round(((parseFloat(rewardMulty[stakePeriod]) * (currentRewardRate * 100)) + Number.EPSILON) * 100) / 100)).toLocaleString(),
                            " OGY")),
                    react_1.default.createElement(origyn_art_ui_1.HR, null),
                    react_1.default.createElement(origyn_art_ui_1.Container, { padding: "32px 48px" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { justify: 'flex-end' },
                            react_1.default.createElement(origyn_art_ui_1.Button, { onClick: handleCloseStake }, "Cancel"),
                            react_1.default.createElement(origyn_art_ui_1.Button, { onClick: () => handleStake() }, "Stake OGY")))))))))));
};
exports.default = Stakes;
const AmountInputWrap = styled_components_1.default.div `
  position: relative;
`;
const StyledPrincipal = styled_components_1.default.div `
  max-width: 100%;
  text-overflow: elipsis;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0.5;

  p {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  button {
    flex-shrink: 0;
  }
`;
const PrincipalBlock = ({ text, ...props }) => {
    return (react_1.default.createElement(StyledPrincipal, { ...props },
        react_1.default.createElement("p", null, text),
        react_1.default.createElement(origyn_art_ui_1.Button, { iconButton: true, size: 'medium', onClick: () => {
                navigator.clipboard.writeText(text);
            } },
            react_1.default.createElement("svg", { type: "button", xmlns: "http://www.w3.org/2000/svg", width: "24", height: "25", viewBox: "0 0 24 25", fill: "none" },
                react_1.default.createElement("path", { d: "M9 18.2354C8.45 18.2354 7.97933 18.0397 7.588 17.6484C7.196 17.2564 7 16.7854 7 16.2354V4.23535C7 3.68535 7.196 3.21435 7.588 2.82235C7.97933 2.43102 8.45 2.23535 9 2.23535H18C18.55 2.23535 19.021 2.43102 19.413 2.82235C19.8043 3.21435 20 3.68535 20 4.23535V16.2354C20 16.7854 19.8043 17.2564 19.413 17.6484C19.021 18.0397 18.55 18.2354 18 18.2354H9ZM9 16.2354H18V4.23535H9V16.2354ZM5 22.2354C4.45 22.2354 3.979 22.0397 3.587 21.6484C3.19567 21.2564 3 20.7854 3 20.2354V7.23535C3 6.95202 3.096 6.71435 3.288 6.52235C3.47933 6.33102 3.71667 6.23535 4 6.23535C4.28333 6.23535 4.521 6.33102 4.713 6.52235C4.90433 6.71435 5 6.95202 5 7.23535V20.2354H15C15.2833 20.2354 15.521 20.3314 15.713 20.5234C15.9043 20.7147 16 20.952 16 21.2354C16 21.5187 15.9043 21.756 15.713 21.9474C15.521 22.1394 15.2833 22.2354 15 22.2354H5ZM9 4.23535V16.2354V4.23535Z" })))));
};
exports.PrincipalBlock = PrincipalBlock;
const StyledProgress = styled_components_1.default.div `
  max-width: 100%;
  width: 100%;
  position: relative;
  border-bottom: 2px solid #242424;
  margin: 16px 0 48px 0;

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 2px;
    width: ${({ progress }) => progress}%;
    background: ${({ theme }) => theme.colors.TEXT};
  }
`;
const StyledProgressSelect = styled_components_1.default.div `
  max-width: 100%;
  width: 100%;
  position: relative;
  border-bottom: 2px solid #FEFEFE;
  margin: 64px 0;

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 2px;
    width: ${({ index }) => parseInt(index) * 18}%;
    background: linear-gradient(45deg, ${({ index }) => rewardColorsStart[index]}, ${({ index }) => rewardColors[index]});
  }

  & > div {
    position: absolute;
    display: flex;
    flex-flow: column;
    align-items: center;
    gap: 12px;
    transform: translate(-50%, -5px);
    cursor: pointer;

    &:before {
      content: "";
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #FEFEFE;
    }


    &.active:before {
      background: ${({ index }) => rewardColors[index]};
    }
  }
`;
const CustomSliderSelect = ({ value, onChange }) => {
    return (react_1.default.createElement(StyledProgressSelect, { index: value },
        react_1.default.createElement("div", { style: { left: "18%" }, onClick: () => onChange('1'), className: parseInt(value) >= 1 ? "active" : "" }, "1 Year"),
        react_1.default.createElement("div", { style: { left: "36%" }, onClick: () => onChange('2'), className: parseInt(value) >= 2 ? "active" : "" }, "2 Years"),
        react_1.default.createElement("div", { style: { left: "54%" }, onClick: () => onChange('3'), className: parseInt(value) >= 3 ? "active" : "" }, "3 Years"),
        react_1.default.createElement("div", { style: { left: "72%" }, onClick: () => onChange('4'), className: parseInt(value) >= 4 ? "active" : "" }, "4 Years"),
        react_1.default.createElement("div", { style: { left: "90%" }, onClick: () => onChange('5'), className: parseInt(value) >= 5 ? "active" : "" }, "5 Years")));
};
